module.exports = __webpack_public_path__ + "static/img/0401_03.21d4162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0401_03.png
// module id = nPF1
// module chunks = 1